import { z } from "zod";

// ─── Request schema ───────────────────────────────────────────────────────────

export const SheetsFinanceExportRequestSchema = z
  .object({
    from: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, { message: "from must be YYYY-MM-DD" })
      .optional(),
    to: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, { message: "to must be YYYY-MM-DD" })
      .optional(),
    statement_id: z.string().uuid({ message: "statement_id must be a valid UUID" }).optional(),
    overwrite: z.boolean().default(false),
  })
  .refine((d) => (d.from === undefined) === (d.to === undefined), {
    message: "from and to must both be provided or both omitted",
  })
  .refine((d) => !d.from || !d.to || d.from <= d.to, {
    message: "from must be ≤ to",
  });

export type SheetsFinanceExportRequest = z.infer<typeof SheetsFinanceExportRequestSchema>;

// ─── Result type ──────────────────────────────────────────────────────────────

export interface SheetsFinanceExportResult {
  written: {
    faktury_przychody: number;
    faktury_koszty: number;
    koszty_zestawienie: number;
    przychody_zestawienie: number;
  };
  skipped_duplicates: {
    faktury_przychody: number;
    faktury_koszty: number;
    koszty_zestawienie: number;
    przychody_zestawienie: number;
  };
  errors: Array<{
    worksheet: string;
    record_id: string | null;
    message: string;
  }>;
}
